import { render } from "./AdminHomeView.vue?vue&type=template&id=d833517a&scoped=true"
import script from "./AdminHomeView.vue?vue&type=script&lang=js"
export * from "./AdminHomeView.vue?vue&type=script&lang=js"

import "./AdminHomeView.vue?vue&type=style&index=0&id=d833517a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d833517a"]])

export default __exports__